import { call, put, select } from 'redux-saga/effects';
import type { SagaIterator } from 'redux-saga';
import { streamActions, withOffset } from '../../Stream';
import { requestPuppy } from '@wix/da-http-client';
import type { Action } from 'redux-actions';
import type { MoveGallectionPayload } from '../actions';
import {
  getCurrentMediaSource,
  getGallectionById,
  getCurrentFolderId,
  getGrusername,
} from '../selectors';
import type { PapiRequestDaSharedGallectionFoldersMove } from '@wix/da-papi-types';
import { getGallectionStreamId, getGallectionType } from '../helpers';
import { normalizeGallection } from '../../redux/normalizr/helpers';

export default function* (action: Action<MoveGallectionPayload>): SagaIterator {
  const { folderId, toFolderId } = action.payload!;

  const mediaSource: ReturnType<typeof getCurrentMediaSource> = yield select(
    getCurrentMediaSource
  );
  const currentFolderId: ReturnType<typeof getCurrentFolderId> = yield select(
    getCurrentFolderId
  );
  const gallection: ReturnType<typeof getGallectionById> = yield select(
    getGallectionById,
    folderId
  );
  const username: ReturnType<typeof getGrusername> = yield select(
    getGrusername
  );

  if (!gallection) {
    return;
  }

  const streamId = getGallectionStreamId(mediaSource, currentFolderId);

  yield put(streamActions.deleteItem({ streamId, item: folderId }));

  const updatedGallection = {
    ...gallection,
    parentId: toFolderId ?? null,
  };
  const entities = normalizeGallection(updatedGallection);

  yield put(streamActions.deleteItem({ streamId, item: folderId }));

  const moveToStreamId = getGallectionStreamId(mediaSource, toFolderId);

  yield put(
    withOffset.actions.insertItems({
      streamId: moveToStreamId,
      items: [folderId],
      offset: 0,
      entities,
    })
  );

  const params: PapiRequestDaSharedGallectionFoldersMove = {
    username,
    type: getGallectionType(mediaSource) ?? 'collection',
    folderid: folderId,
    to_folderid: toFolderId,
  };

  yield call(requestPuppy, {
    method: 'post',
    url: 'gallection/folders/move',
    data: params,
  });
}
